const VACANCYCARDTHEMES = {
    yellow: 'yellow',
    white: 'white',
    default: 'default'
};

module.exports.default = module.exports.VACANCYCARDTHEMES = VACANCYCARDTHEMES;


// WEBPACK FOOTER //
// ./src/constants/vacancyCardThemes.js